module.exports = __webpack_public_path__ + "img/burundi.bec6fbd.webp";